<template>
  <div class="typed-on-paper-tabs-padding">

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">Persistent Characters</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">Briefings</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">Missions</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">De-briefings</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">After Action Reports</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">Claims & Victories</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">Awards & Medals</div>-->
<!--    </DivLinkButton>-->


  </div>
</template>

<script>
import DivLinkButton from "../basic_comp/DivLinkButton"
import HideableDiv from "../basic_comp/HideableDiv"

export default {
  name: "CampaignsInfoSideNav",
  components: {
    DivLinkButton,
    HideableDiv
  },
  methods: {

    navigate_to: function (link) {

      location.replace(link);
    }
  }

}
</script>

<style scoped>

.subcontent-buttons{
  font-size: 1em;
  margin: 2px 0px 0px 15px;
  width: calc(100% - 15px - 26px);
}

</style>



// WEBPACK FOOTER //
// src/components/info/CampaignsInfoSideNav.vue